import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  isDevMode,
  NgModule,
} from "@angular/core";
import { RouterModule, NavigationEnd, Router } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { datadogRum } from "@datadog/browser-rum";
import { filter } from "rxjs/operators";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { SharedModule } from "./shared/shared.module";
import { AuthInterceptor } from "./services/auth.interceptor";
import { LandingComponent } from "./landing/landing.component";
import { ToastModule } from "primeng/toast";
//import { MessageService } from 'primeng/api';
import { MultiSelectModule } from "primeng/multiselect";
import { UnauthorizedPageComponent } from "./unauthorized/unauthorized.component";
import { DatadogRumService } from "./services/datadog-rum.service";
import { environment } from "../environments/environment";
import { StateService } from "./services/state.service";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { MessageService } from "primeng/api";

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LandingComponent,
    UnauthorizedPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    OverlayModule,
    PortalModule,
    StoreModule.forRoot(
      {},
      {
        metaReducers: [],
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
        },
      },
    ),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 50, logOnly: !isDevMode() }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedModule,
    HttpClientModule,
    ToastModule,
    MultiSelectModule,
    RouterModule.forRoot([]),
    //ToastModule,
  ],
  providers: [
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    //MessageService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    router: Router,
    private datadogRumService: DatadogRumService,
    private stateService: StateService,
  ) {
    const domainType = this.stateService.checkAppConfig();
    // Same gate as DatadogRumService: enable in prod, or in dev when the
    // `enableRumInDev` flag is on (for testing the planogram-telemetry feature).
    const enableRum =
      (environment.production ||
        (environment as any).enableRumInDev === true) &&
      domainType !== "pho";
    if (enableRum) {
      router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: any) => {
          datadogRum.addAction("Navigation", { path: event.urlAfterRedirects });
          datadogRum.startView(event.urlAfterRedirects);
        });
      this.datadogRumService.setUser();
    }
  }
}
